import { Divider as DividerAntd } from 'antd';
import styled from 'styled-components';

export const AdditionalComments = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  position: relative;
`;

export const Divider = styled(DividerAntd)`
  margin-top: 50px;
`;
